import { useState } from 'react';
import { UserJourney, ContentItem } from '@/types/journey';
import { usePersistJourneyData } from './usePersistJourneyData';
import { useStageOperations } from './useStageOperations';
import { useZoomControls } from './useZoomControls';
import { DEFAULT_STAGES, DEFAULT_JOURNEY, STORAGE_KEY, JOURNEY_KEY } from '@/data/journeyDefaults';

export const useJourneyMap = () => {
  const [stages, setStages] = usePersistJourneyData<typeof DEFAULT_STAGES>({ 
    storageKey: STORAGE_KEY, 
    defaultValue: DEFAULT_STAGES 
  });
  
  const [journey, setJourney] = usePersistJourneyData<UserJourney>({ 
    storageKey: JOURNEY_KEY, 
    defaultValue: DEFAULT_JOURNEY 
  });
  
  const stageOperations = useStageOperations(stages, setStages);
  const zoomControls = useZoomControls();

  const handleProfileUpdate = (updatedProfile: Partial<UserJourney>) => {
    console.log('handleProfileUpdate called with:', updatedProfile);
    setJourney((currentJourney) => {
      const newJourney = {...currentJourney, ...updatedProfile};
      console.log('Updated journey:', newJourney);
      return newJourney;
    });
  };

  const handleMapNameChange = (name: string) => {
    setJourney((currentJourney) => ({...currentJourney, mapName: name}));
  };

  const handleClearAll = () => {
    setStages([]);
    
    // Create an empty journey object instead of using DEFAULT_JOURNEY
    const emptyJourney: UserJourney = {
      userName: '',
      userRole: '',
      userPhoto: null,
      scenario: '',
      goal: '',
      mapName: 'Untitled user journey',
      insights: {
        gaps: '',
        opportunities: ''
      },
      insightItems: [
        {
          id: 'insight-opportunities-empty',
          type: 'opportunities',
          content: []
        },
        {
          id: 'insight-internalOwnership-empty',
          type: 'internalOwnership',
          content: []
        },
        {
          id: 'insight-successMetrics-empty',
          type: 'successMetrics',
          content: []
        }
      ]
    };
    
    setJourney(emptyJourney);
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(JOURNEY_KEY);
  };

  return {
    stages,
    journey,
    setStages,
    setJourney,
    ...stageOperations,
    ...zoomControls,
    handleProfileUpdate,
    handleMapNameChange,
    handleClearAll,
  };
};
